/*
  File: {file_name}
  Author: Binish Mookken
  Date: April-June 2024

  Description:

*/

/*
  File: Login.css
  Author: Binish Mookken
  Date: April-June 2024

  Description:

*/

import { Typography, List } from "antd";
import { Agent } from "./types";

interface ReviewComponentProps {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  hasAccess: boolean;
  referringAgent: Agent | null;
}

const { Text } = Typography;

const ReviewComponent: React.FC<ReviewComponentProps> = ({
  firstName,
  lastName,
  email,
  phone,
  hasAccess,
  referringAgent,
}) => {
  const requiredFields = ["firstName", "lastName", "email", "phone"];

  const hasErrors = requiredFields.some((field) => {
    return !firstName || !lastName || !email || !phone;
  });

  return (
    <div style={{ marginTop: "30px" }}>
      <div className="step-header">Review</div>
      <div className="step-header-subtext">
        Ensure the info below is accurate and all required fields are populated.
        Use the process flow above to make edits as needed. Click done to
        complete.
      </div>
      <List size="small">
        <List.Item
          style={{ color: hasErrors && !firstName ? "red" : "inherit" }}
        >
          <Text strong>First Name:</Text> {firstName}
          {hasErrors && !firstName && (
            <span style={{ marginLeft: "5px" }}>(Required)</span>
          )}
        </List.Item>
        <List.Item
          style={{ color: hasErrors && !lastName ? "red" : "inherit" }}
        >
          <Text strong>Last Name:</Text> {lastName}
          {hasErrors && !lastName && (
            <span style={{ marginLeft: "5px" }}>(Required)</span>
          )}
        </List.Item>
        <List.Item style={{ color: hasErrors && !email ? "red" : "inherit" }}>
          <Text strong>Email:</Text> {email}
          {hasErrors && !email && (
            <span style={{ marginLeft: "5px" }}>(Required)</span>
          )}
        </List.Item>
        <List.Item style={{ color: hasErrors && !phone ? "red" : "inherit" }}>
          <Text strong>Phone:</Text> {phone}
          {hasErrors && !phone && (
            <span style={{ marginLeft: "5px" }}>(Required)</span>
          )}
        </List.Item>
        <List.Item>
          <Text strong>System Access:</Text> {hasAccess ? "Yes" : "No"}
        </List.Item>
        <List.Item>
          <Text strong>Referring Agent:</Text>{" "}
          {referringAgent?.first_name
            ? `${referringAgent.first_name} ${
                referringAgent.last_name || "None"
              }`
            : "None"}
        </List.Item>
      </List>
    </div>
  );
};

export default ReviewComponent;
